/*
 * @Description: 文件内容
 * @Author: dali
 * @Date: 2021-04-18 15:24:16
 * @LastEditors: dali
 * @LastEditTime: 2022-09-27 10:39:46
 */
import React, { Component, Fragment } from 'react'
import { Button, Statistic, message } from 'antd'
import styles from './count.scss'
const { Countdown } = Statistic

class CountDownBtn extends Component {
  constructor(props) {
    super(props)
    this.defaultWarn = '认证出错'
    this.btnDesc = props.desc || '发送验证码'
    this.state = {
      deadline: Date.now(),
      reqFlag: false
    }
  }
  onFinish() {
    this.setState({
      reqFlag: false
    })
    console.log('finished!')
  }
  handleReset() {
    this.setState({
      reqFlag: false,
      deadline: Date.now()
    })
  }
  handleBtnClick() {
    this.props.handleSend().then(()=>{
      this.setState({
        reqFlag: true,
        deadline: Date.now() + ((1000 * this.props.countTime) || 1000 * 60)
      })
    }).catch((err)=>{
      console.log('errrrrr', err)

      message.error(err.message || this.defaultWarn)
    })
  }
  render() {
    return (
      <Fragment >
        <Button type='primary' disabled={this.state.reqFlag} className={styles['count-btn']} onClick={this.handleBtnClick.bind(this)}>
          {
            this.state.reqFlag ? <Countdown value={this.state.deadline} format='ss' onFinish={this.onFinish.bind(this)}/> : <span>{this.btnDesc}</span>
          }

        </Button>
      </Fragment>
    )
  }
}

export default CountDownBtn
